import { AbilityBuilder, createMongoAbility, MongoAbility } from '@casl/ability'
import { intersection } from 'ramda'

import { UserRole } from './types'

export type Actions = 'impersonate' | 'update'
export type Subjects = 'user' | 'user-settings' | 'document-read-status'

export type AppAbility = MongoAbility<[Actions, Subjects]>

export const defineAbilityFor = (roles?: UserRole[]): AppAbility => {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(
    createMongoAbility,
  )

  if (roles?.includes(UserRole.Customer)) {
    can('update', 'user-settings')
    can('update', 'document-read-status')
  }

  if (roles?.includes(UserRole.ImpersonatedUser)) {
    can('impersonate', 'user')
    cannot('update', 'document-read-status')
    cannot('update', 'user-settings')
  }

  return build()
}

const customerAppRoles = [UserRole.Customer]

export function isCustomerAppRole(roles?: UserRole[]) {
  if (!roles) return false
  return intersection(customerAppRoles, roles).length > 0
}
